module.exports = __webpack_public_path__ + "img/scroll_pc.463f8e8d.png";